import { AppHelper } from '../../shared/appHelper/appHelper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TServicePagingResult } from '../../shared/Infra/TServicePagingResult';
import { TServiceResult } from '../../shared/Infra/TServiceResult';
import { ServiceResult } from '../../shared/Infra/ServiceResult';
import { SearchFilter } from '../../shared/Infra/Expression/search-filter';
import { Observable } from 'rxjs';
import { LocalRepository } from '../data/repository/local-repository';
import { JwtHelperService } from '@auth0/angular-jwt';
import { isArray } from 'util';
import * as uuid from 'uuid';
import { CLIENT_ID_KEY } from '../services/refresh-token-service/refresh-token-service';
import { CategoryReferenceEnum } from '../enums/categoryReferenceEnum';


const ACCESS_TOKEN_KEY = 'access_token';
const API_HEADER_KEY = 'apiVersion';
const REFERESH_TOKEN_KEY = 'refresh_token';
const EXPIRE_IN_KEY = 'expires_in';
const GOLRIZ_CODE_KEY = 'golrizCode';

export class ServiceBase<T> {

  protected ApiUrl = AppHelper.BaseUrl;
  public ApiVersion1 = 1.0;
  public ApiVersion2 = 2.0;
  public ApiHeaderKey = API_HEADER_KEY;
  jwtHelper: JwtHelperService;

  constructor(apiParam: string, protected http: HttpClient,
    private repository: LocalRepository) {
    this.ApiUrl += apiParam;
    this.jwtHelper = new JwtHelperService();
  }



  public getByFilter(filter: SearchFilter): Observable<TServicePagingResult<T[]>> {
    return this.http.post<TServicePagingResult<T[]>>(`${this.ApiUrl}/GetItemsByFilter`, filter);
  }

  public getAllAwait(): Promise<TServiceResult<T[]>> {
    return this.http.get<TServiceResult<T[]>>(`${this.ApiUrl}/GetAll`).toPromise();
  }

  public getAll(): Observable<TServiceResult<T[]>> {
    return this.http.get<TServiceResult<T[]>>(`${this.ApiUrl}/GetAll`);
  }

  public getById(id: number): Observable<TServiceResult<T>> {
    return this.http.get<TServiceResult<T>>(`${this.ApiUrl}/GetById/${id}`);
  }

  public Add(item): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(`${this.ApiUrl}/Add`, item);
  }

  public Edit(item): Observable<TServiceResult<T>> {
    return this.http.put<TServiceResult<T>>(`${this.ApiUrl}/Edit`, item)
  }

  public Remove(id: number): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(`${this.ApiUrl}/Remove/${id}`)
  }


  /**
   * use this method to access Local Storage or SessionStorage
   */
  public get Repository(): LocalRepository {
    return this.repository;
  }


  /**
   * getAccessToken
   */
  public getAccessToken() {
    return this.Repository.getItem(ACCESS_TOKEN_KEY);
  }

  public isTokenValid(token: string): boolean {
    if (token == null || token === '') {
      return false;
    }
    let date = this.jwtHelper.getTokenExpirationDate(token);
    if (date === null) { return true; }
    return date.valueOf() > new Date().valueOf() + AppHelper.tokenExpiryOffsetSeconds * 1000;
  }

  public get IsUserLogin(): boolean {
    return !!this.getAccessToken(); //&& this.isTokenValid(this.getAccessToken());
  }


  public get GetUserRoles(): string[] {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return null;
    const tmpR = DECODED_TOKEN['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    let Roles = [];
    if (tmpR && !isArray(tmpR))
      Roles = (tmpR as string).split(',');
    else if (tmpR)
      Roles = (tmpR as string[]).map(x => x);
    return Roles;
  }

  public get IsAdmin(): boolean {
    const ROLES = this.GetUserRoles;
    if (ROLES && ROLES.length > 0)
      if (ROLES.find(r => r != 'Hamyar'))
        return true;
    return false;
  }


  public get IsSayehAdmin(): boolean {
    const ROLES = this.GetUserRoles;
    if (ROLES && ROLES.length > 0)
      if (ROLES.find(r => r === 'مدیریت-سایه' || r === 'Master'))
        return true;
    return false;
  }

  public get IsMaster(): boolean {
    const ROLES = this.GetUserRoles;
    if (ROLES && ROLES.length > 0)
      if (ROLES.find(r => r === 'Master'))
        return true;
    return false;
  }





  public get UserCurrentBranchId(): number {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return -1;
    return +DECODED_TOKEN['branchId'] || -1;
  }

  public get UserCurrentBranchName(): string {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return "";
    return DECODED_TOKEN['branchName'] || "خیریه";
  }


  public get UserCurrentFirstname(): string {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return "";
    return DECODED_TOKEN['FName'] || "کاربر";
  }
  public get UserCurrentLastname(): string {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return "";
    return DECODED_TOKEN['LName'] || "کاربر";
  }
  public get UserCurrentId(): string {
    const DECODED_TOKEN = this.jwtHelper.decodeToken(this.getAccessToken());
    if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
      return "";
    return DECODED_TOKEN['userId'];
  }


  public get UserCurrentFullname(): string {
    return this.UserCurrentFirstname + " " + this.UserCurrentLastname;
  }


  public get IsInBrowser(): boolean {
    return this.repository.IsInBrowser;
  }


  clearUserDataStored() {
    this.Repository.remove(ACCESS_TOKEN_KEY);
    this.Repository.remove(EXPIRE_IN_KEY);
    this.Repository.remove(REFERESH_TOKEN_KEY);
    this.Repository.remove(GOLRIZ_CODE_KEY);
  }



  public get ClientId(): string {
    let clientId = this.Repository.getItem(CLIENT_ID_KEY);
    if (!clientId) {
      clientId = uuid.v4();
      this.Repository.setItem(CLIENT_ID_KEY, clientId);
    }
    return clientId;
  }





}
